'use client';
import { IonButton, IonButtons, IonIcon, IonModal, IonTitle, IonToolbar } from '@ionic/react';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { shareOutline } from 'ionicons/icons';
import ShareForm from './ShareForm';

export default function ShareDialog({ username }: { username: string }) {
  const [isOpen, setIsOpen] = useState(false);
  const modal = useRef<HTMLIonModalElement>(null);
  const { t } = useTranslation();

  const handleDismiss = () => {
    setIsOpen(false);
  };

  return (
    <>
      <IonButton
        type="button"
        fill="outline"
        shape="round"
        className="rounded-full text-muted-foreground"
        onClick={() => setIsOpen(true)}
      >
        <IonIcon icon={shareOutline} className="size-6" />
        <span className="text-muted-foreground">{t('share')}</span>
      </IonButton>

      <IonModal
        ref={modal}
        isOpen={isOpen}
        onDidDismiss={handleDismiss}
        className="auto-height"
      >
        <IonToolbar>
          <IonTitle>{t('share_profile')}</IonTitle>
          <IonButtons slot="end">
            <IonButton className="font-bold" onClick={handleDismiss}>{t('done')}</IonButton>
          </IonButtons>
        </IonToolbar>

        <ShareForm profileId={username} />
      </IonModal>
    </>
  );
}


